// Entry point for the build script in your package.json

// Adding ujs to enable remote: true, methods inside buttons etc
import Rails from "@rails/ujs"
Rails.start()

import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap; // Make Bootstrap globally available

// Iconify
// import Iconify from '@iconify/iconify';
// window.Iconify = Iconify; // Make it global

// Import SimpleBar JS
import SimpleBar from "simplebar";

// Material Pro
import "./theme/app.init.js"
import * as featherIcons from "./theme/feather.min.js";
window.feather = featherIcons;
import "./theme/theme.js"
import "./theme/app.min.js"
import "./theme/sidebarmenu.js"
import "./theme/iconify-icon.min.js"
import "./material_pro_init.js"
import "./sidebar_active.js"
import "./initialize_choices.js"
import "trix"
import "@rails/actiontext"
import ApexCharts from "apexcharts"
window.ApexCharts = ApexCharts

// Active storage
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

// Modal loader
import { initializeAjaxModals } from "./modal_loader"
initializeAjaxModals()
